module.exports = __webpack_public_path__ + "static/media/2_pl.9f10daaa.png";